<div class="monitor-dashboard-section-shell">
    <div class="monitor-dashboard-panel-row">

        <!-- 1 -->
        <div class="monitor-dashboard-panel-item">
            <requests-by-sms-provider-and-sender-type-chart ref="requestsBySmsProviderAndSenderType" :filter="filter">
            </requests-by-sms-provider-and-sender-type-chart>
        </div>

        <!-- 2 -->
        <div class="monitor-dashboard-panel-item">
            <active-senders-timeline-chart ref="activeSendersTimeline" :filter="filter">
            </active-senders-timeline-chart>
        </div>

        <!-- 3 -->
        <div class="monitor-dashboard-panel-item">
            <sender-expiration-timeline-chart ref="senderExpirationTimeline" :filter="filter">
            </sender-expiration-timeline-chart>
        </div>

        <!-- 4 -->
        <div class="monitor-dashboard-panel-item">
            <sender-renewal-timeline-chart ref="senderRenewalTimeline" :filter="filter">
            </sender-renewal-timeline-chart>
        </div>

        <!-- 5 -->
        <div class="monitor-dashboard-panel-item">
            <senders-duration-chart ref="sendersDuration" :filter="filter">
            </senders-duration-chart>
        </div>

        <!-- 6 -->
        <div class="monitor-dashboard-panel-item">
            <senders-by-nodes-chart ref="sendersByNodes" :filter="filter" :tenants="tenants">
            </senders-by-nodes-chart>

        </div>

        <!-- 7 -->
        <div class="monitor-dashboard-panel-item">
            <sender-name-length-compliance-chart ref="senderNameLengthCompliance" :filter="filter">
            </sender-name-length-compliance-chart>
        </div>

    </div>
</div>